var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',_vm._g({staticClass:"header-action"},_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.$slots.badge)?_c('div',{staticClass:"header-action__badge"},[_vm._t("badge")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }